import React from 'react';

import {ProgressDeepResearchMessage, ProgressMessage} from 'llm/deep-research/messages/DeepResearchProgress';
import {ReportDeepResearchMessage, ReportMessage} from 'llm/deep-research/messages/DeepResearchReport';
import {UserDeepResearchMessage, UserMessage} from 'llm/deep-research/messages/DeepResearchUserMessage';
import {DeepResearchMessageType} from 'llm/deep-research/types';
import {assertNever} from 'util/Types';

export type DeepResearchMessage =
  | UserDeepResearchMessage
  | ReportDeepResearchMessage
  | ProgressDeepResearchMessage;

export interface DeepResearchMessageComponentProps {
  message: DeepResearchMessage;
  isSubmitting: boolean;
}

export function DeepResearchMessageComponent({
  message,
  isSubmitting,
}: DeepResearchMessageComponentProps): JSX.Element {
  switch (message.type) {
    case DeepResearchMessageType.USER_MESSAGE:
      return <UserMessage message={message} />;
    case DeepResearchMessageType.PROGRESS:
      return <ProgressMessage message={message} isSubmitting={isSubmitting} />;
    case DeepResearchMessageType.SYSTEM_REPORT:
      return <ReportMessage message={message} />;
    default:
      assertNever(message);
      throw new Error(`Unexpected message type`);
  }
}
